  // $(window).bind("load", function() {
  //   $('.image-zoom')
  //   .wrap('<span style="display:inline-block"></span>')
  //   .css('display', 'block')
  //   .parent()
  //   .zoom({
  //     url: $(this).find('img').attr('data-zoom')
  //   });
  //  console.log("Inside the zoom function");
  // });
$(".collection-switcher-item").click(function () {
  var dataClass = $(this).attr("data-Class");
  var dataUrl= $(this).attr("data-url");
  $(".collection-switcher-item").removeClass("active");
  $(".switcher-collection .product-list").addClass("hide");
  $(this).addClass("active");
  $("." + dataClass).removeClass("hide");
$(".switcher-collection .view-all-link").prop("href",  dataUrl);
});
$(document).ready(function() {
  $('.tooltip').click(function() {
    var tooltipId = $(this).attr('id');
    
    // Hide other open tooltip content boxes
    $('.tooltip').not('#' + tooltipId).removeClass('show');
    
    // Toggle the current tooltip content box
    $('#' + tooltipId).toggleClass('show');
    $(".slideshow-v3 .slick-dots").toggleClass("tool-active")
  });
  $(document).mouseup(function(e) {
    var container = $(".tooltip");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
     $('.tooltip').removeClass('show');
        $(".slideshow-v3 .slick-dots").removeClass("tool-active")
      }
   })
  //    $('.product-block-svgicon').click(function() {
  //      $(".tooltiptext").removeClass("active");
  //      $(".product-block-svgicon").removeClass("active");
  //       $(this).addClass("active");
  //      $(this).find(".tooltiptext").addClass("active");
  //    })
  // $(document).mouseup(function(e) {
  //   var container = $(".product-block-svgicon");
  //     if (!container.is(e.target) && container.has(e.target).length === 0) {
  //    $(".tooltiptext").removeClass('active');
  //        $(".product-block-svgicon").removeClass("active");
  //     }
  //  })
  $('.layout-3-pro').click(function() {
    $(".layout-switch").removeClass("active");
    $(this).addClass("active");
    $(".product-list-container .product-block").css({"width": "33.3%"});
  })
  $('.layout-4-pro').click(function() {
    $(".layout-switch").removeClass("active");
    $(this).addClass("active");
    $(".product-list-container .product-block").css({"width": "25%"});
  })
   $('.layout-2-pro').click(function() {
    $(".layout-switch").removeClass("active");
    $(this).addClass("active");
    $(".product-list-container .product-block").css({"width": "50%"});
  })
  $('.layout-1-pro').click(function() {
    $(".layout-switch").removeClass("active");
    $(this).addClass("active");
    $(".product-list-container .product-block").css({"width": "100%"});
  })
  // $(".fm_drawer .cc-accordion-item").click(function() {
  //   setTimeout(function() {
  //   $(".fm_drawer .cc-accordion-item").prop('open', false);
  //   $(".fm_drawer .cc-accordion-item").removeClass('is-open');
  //   $(this).prop('open', true);
  //    $(this).addClass('is-open');
  //      }, 1000);
  // })
});
// $('.color-swatches-options').click(function() {
//    var dataImage1 = $(this).attr("data-image-1");
//   var dataImage2 = $(this).attr("data-image-2");
//   $(this).parents('.product-block__inner').find(".image-inner .image__first img").attr('srcset', dataImage1 );
//    $(this).parents('.product-block__inner').find(".image-inner .image__second img").attr('srcset', dataImage2 );
// })
if($(window).innerWidth() <= 767) {
   $(".text-icon-slider").slick({
        infinite: true,
        arrows: false,
        dots: true,
        autoplay: true,
        speed: 500,
        autoplaySpeed:2000,
        slidesToShow: 2,
        slidesToScroll: 2
    });

    //ticking machine
    var percentTime;
    var tick;
    var time = 1;
    var progressBarIndex = 0;

    var progress = $('.inProgress');

    $('.progressBarContainer .progressBar').each(function (index) {
        var progress = "<div class='inProgress inProgress" + index + "'></div>";
        $(this).html(progress);
    });

    function startProgressbar() {
        resetProgressbar();
        percentTime = 0;
        tick = setInterval(interval, 10);
    }

    function interval() {
        if (($('.text-icon-slider .slick-track div[data-slick-index="' + progressBarIndex + '"]').attr("aria-hidden")) === "true") {
            progressBarIndex = $('.text-icon-slider .slick-track div[aria-hidden="false"]').data("slickIndex");

            console.log(progressBarIndex);

            if (progressBarIndex == 1) {
                $(".inProgress0").addClass('on');
                $(".inProgress1").removeClass('on');
            }
            else if (progressBarIndex == 2) {
                $(".inProgress0").addClass('on');
                $(".inProgress1").addClass('on');
            }
            else if (progressBarIndex == 0) {
                $(".inProgress0").removeClass('on');
                $(".inProgress1").removeClass('on');
            }
            startProgressbar();

        } else {
            percentTime += 1 / (time + 2);
            $('.inProgress' + progressBarIndex).css({
                width: percentTime + "%"
            });
            if (percentTime >= 100) {
                $('.single-item').slick('slickNext');

                //console.log(progressBarIndex);

                if (progressBarIndex == 0) {
                    $(".inProgress0").addClass('on');

                }
                else if (progressBarIndex == 1) {
                    $(".inProgress0").addClass('on');
                    $(".inProgress1").addClass('on');
                }
                else if (progressBarIndex == 2) {
                    $(".inProgress0").removeClass('on');
                    $(".inProgress1").removeClass('on');
                }

                progressBarIndex++;

                if (progressBarIndex > 2) {
                    progressBarIndex = 0;
                }
                startProgressbar();

            }

        }
    }

    function resetProgressbar() {
        $('.inProgress').css({
            width: 0 + '%'
        });
        clearInterval(tick);
    }
    startProgressbar();
    // End ticking machine

    $('.progressBarContainer div').click(function () {
        clearInterval(tick);
        var goToThisIndex = $(this).find("span").data("slickIndex");
        $('.single-item').slick('slickGoTo', goToThisIndex, false);
        startProgressbar();
    });
}

  if($(window).innerWidth() <= 768) {
        $('.twp-wrapper-right-flex').slick({
       centerMode: true,
        centerPadding: '120px',
        slidesToShow: 1
});
var _height = $(".SEO-Insert-left").height();
    _height = _height + 40;
 $(".SEO-Insert-flex").css("max-height", _height + "px");
    }
 jQuery(".filter_icon").click(function(){
      jQuery('.fm_drawer').addClass('show_drawer');
      jQuery('#site-control').addClass('low_index');
      jQuery('.cc-accordion-item').prop('open', true);
      jQuery('.cc-accordion-item').addClass('is-open');
    });
    jQuery(".fm_drawer_close").click(function(){
      jQuery('.fm_drawer').removeClass('show_drawer');
      jQuery('#site-control').removeClass('low_index');
    });
$(".mobile-menu-a").click(function () {
  $(this).toggleClass("active");
  $(this).siblings("ul").slideToggle();
  $(this).siblings("ul").toggleClass("active");
})

$('.custom-link a').click(function (e) {
   e.preventDefault();
   var copyText = $(this).attr('href');

   document.addEventListener('copy', function(e) {
      e.clipboardData.setData('text/plain', copyText);
      e.preventDefault();
   }, true);

   document.execCommand('copy');  
   console.log('copied text : ', copyText);
   // alert('copied text: ' + copyText); 
 });

  $(".SEO-Insert-btn").click(function(){
    // $(".SEO-Insert p").css("display", "block");
    $(this).parents(".SEO-Insert_container").find(".SEO-Insert-flex").toggleClass("open")
    $(".SEO-Insert-btn").toggleClass("hide");
  });